/**
 * Which internal document a chapter/release belongs to. One authoring module serves all
 * of them — copying it per document would duplicate ~2000 lines and diverge on the next fix.
 *
 * Allowlist, not free text: `docKey` arrives from the client, and an unchecked value would
 * let anyone create documents nobody asked for.
 *
 * Only the handbook asks employees to acknowledge that they read it. Travel expense is a
 * reference document — making the whole company click "I have read this" is noise.
 */
export const DOC_KEYS = ['handbook', 'travel-expense'];
export const DEFAULT_DOC_KEY = 'handbook';
export const ACK_DOC_KEYS = ['handbook'];
/**
 * Tiền tố `category` của câu hỏi thuộc từng văn bản trong ngân hàng thi ("Sổ tay — C3").
 * Ngân hàng thi là bảng dùng chung toàn hệ thống và không có cột "thuộc văn bản nào", nên tiền
 * tố này là ranh giới: cửa sổ tạo đề chỉ liệt kê và chỉ nhận category mang tiền tố của văn bản
 * đang phát hành. Không có nó, câu của một bài thi khác đặt tag "all" cũng lọt vào đề sổ tay.
 */
export const DOC_QUESTION_CATEGORY_PREFIX = {
    handbook: 'Sổ tay',
    'travel-expense': 'Công tác phí',
};
export function isDocKey(value) {
    return typeof value === 'string' && DOC_KEYS.includes(value);
}
//# sourceMappingURL=employee-handbook.contract.js.map